export const LOADER_ID_CHAPTER_PARAS_LOADING = "paras/chapterParas";

export const makeLoaderIdChapterParasLoading = (chapterId) => {
  return LOADER_ID_CHAPTER_PARAS_LOADING + chapterId;
};

export const KEY_REDUCER_PARAGRAPHS = "paragraphReducer";
